import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { HeaderComponent } from 'src/app/navigation/header/header.component';
import { AppComponent } from 'src/app/app.component';
import { ReportComponent } from 'src/app/report/report.component';


@Component({
  selector: 'productinfo',
  templateUrl: './productinfo.component.html',
  styleUrls: ['./productinfo.component.css']
})
export class ProductinfoComponent implements OnInit {

  @ViewChild(HeaderComponent, { static: true }) header: HeaderComponent;
  @ViewChild(AppComponent, { static: true }) apptest: AppComponent;

  @Input() data;

  constructor(
    private changeDet: ChangeDetectorRef,
  ) { }

  checkAllProductInfo = false;

   // Product Info section
   productName;
   productNameChecked = false;
 
   productCode;
   productCodeChecked = false;
 
   manufacturerName;
   manufacturerNameChecked = false;
 
   sdsFile;
   sdsFileChecked = false;
 
   sdsURL;
   sdsURLChecked = false;
 
   creationDate;
   creationDateChecked = false;
 
   modifiedDate;
   modifiedDateChecked = false;
 
   revisionDate;
   revisionDateChecked = false;
 
   productAlias;
   productAliasChecked = false;
 
   sdsOrigin;
   sdsOriginChecked = false;
 
   sdsFormat;
   sdsFormatChecked = false;
 
   discontinued;
   discontinuedChecked = false;
 
   exemptWHMIS;
   exemptWHMISChecked = false;
 
   registrationNumber;
   registrationNumberChecked = false;
 
   additionalSupplier;
   additionalSupplierChecked = false;

   dateAdded;
   dateAddedChecked = false;
   dateAddedDisabled = true;
 
   lastVerifiedDate;
   lastVerifiedDateChecked = false;

   notes;
   notesChecked = false;

   exemptionClass;
   exemptionClassChecked = false;

  ngOnInit() {
    console.log(this.apptest);
    console.log(this.header);
    console.log('Product info');
    console.log(this.data);
  }
disableIt: any;
  ngAfterViewInit() {
    this.disableIt = this.data;
    this.changeDet.detectChanges();
  }

  public onExemptionClassChecked() {
    this.exemptionClass = '';
    if (this.exemptionClassChecked) {
      this.exemptionClass = 'ExemptionClass';
    }
  }

  public onProductNameChecked() {
    this.productName = '';
    if (this.productNameChecked) {
      this.productName = 'ProductName';
    }
  }

  onProductCodeChecked() {
    this.productCode = '';
    if (this.productCodeChecked) {
      this.productCode = 'ProductCode';
    }
  }

  public onManufacturerNameChecked() {
    this.manufacturerName = '';
    if (this.manufacturerNameChecked) {
      this.manufacturerName = 'ManufacturerName';
    }
  }

  onSdsFormatChecked() {
    this.sdsFormat = '';
    if (this.sdsFormatChecked) {
      this.sdsFormat = 'SDSFormat';
    }
  }

  onSdsOriginChecked() {
    this.sdsOrigin = '';
    if (this.sdsOriginChecked) {
      this.sdsOrigin = 'SDSOrigin';
    }
  }

  onCreationDateChecked() {
    this.creationDate = '';
    if (this.creationDateChecked) {
      this.creationDate = 'CreatedDate';
    }
  }

  onDateAddedChecked() {
    this.dateAdded = '';
    if (this.dateAddedChecked) {
      this.dateAdded = 'DateAdded';
    }
  }

  onLastVerifiedDateChecked() {
    this.lastVerifiedDate = '';
    if (this.lastVerifiedDateChecked) {
      this.lastVerifiedDate = 'LastVerifiedDate';
    }
  }

  onModifiedDateChecked() {
    this.modifiedDate = '';
    if (this.modifiedDateChecked) {
      this.modifiedDate = 'DateModified';
    }
  }

  onRevisionDateChecked() {
    this.revisionDate = '';
    if (this.revisionDateChecked) {
      this.revisionDate = 'RevisionDate';
    }
  }

  onProductAliasChecked() {
    this.productAlias = '';
    if (this.productAliasChecked) {
      this.productAlias = 'ProductAlias';
    }
  }

  onDiscontinuedChecked() {
    this.discontinued = '';
    if (this.discontinuedChecked) {
      this.discontinued = 'Discontinued';
    }
  }

  onWHMISExemptChecked() {
    this.exemptWHMIS = '';
    if (this.exemptWHMISChecked) {
      this.exemptWHMIS = 'WHMISExempt';
    }
  }

  // onExemptionClassChecked() {
  //   this.exemptionClass = ""
  //   if (this.exemptionClassChecked) {
  //     this.exemptionClass = "ExemptionClass"
  //   }
  //   console.log("fn " + this.exemptionClass);
  // }

  onRegistrationNumberChecked() {
    this.registrationNumber = '';
    if (this.registrationNumberChecked) {
      this.registrationNumber = 'RegistrationNumber';
    }
  }

  onAdditionalSuppliersChecked() {
    this.additionalSupplier = '';
    if (this.additionalSupplierChecked) {
      this.additionalSupplier = 'AdditionalSuppliers';
    }
  }

  onNotesChecked() {
    this.notes = '';
    if (this.notesChecked) {
      this.notes = 'Notes';
    }
  }

  onSdsFileChecked() {
    this.sdsFile = '';
    if (this.sdsFileChecked) {
      this.sdsFile = 'SDSFile';
    }
  }

  onSDSURLChecked() {
    this.sdsURL = '';
    if (this.sdsURLChecked) {
      this.sdsURL = 'ProductSDSUrl';
    }
  }

  onSelectAllProductinfoClick(event) {
    if (event.checked) {
      this.productNameChecked = true;
      if (this.productNameChecked) {
        this.onProductNameChecked();
      }
      this.productCodeChecked = true;
      if (this.productCodeChecked) {
        this.onProductCodeChecked();
      }
      this.manufacturerNameChecked = true;
      if (this.manufacturerNameChecked) {
        this.onManufacturerNameChecked();
      }
      this.sdsFileChecked = true;
      if (this.sdsFileChecked) {
        this.onSdsFileChecked();
      }
      this.sdsURLChecked = true;
      if (this.sdsURLChecked) {
        this.onSDSURLChecked();
      }
      this.creationDateChecked = true;
      if (this.creationDateChecked) {
        this.onCreationDateChecked();
      }
      if (this.dateAddedDisabled) {
        this.dateAddedChecked = false; 
      } else if (!this.dateAddedDisabled) {
        this.dateAddedChecked = true;
        this.onDateAddedChecked();
      }
      this.lastVerifiedDateChecked = true;
      if (this.lastVerifiedDateChecked) {
        this.onLastVerifiedDateChecked();
      }
      this.notesChecked = true;
      if (this.notesChecked) {
        this.onNotesChecked();
      }
      this.modifiedDateChecked = true;
      if (this.modifiedDateChecked) {
        this.onModifiedDateChecked();
      }
      this.revisionDateChecked = true;
      if (this.revisionDateChecked) {
        this.onRevisionDateChecked();
      }
      this.productAliasChecked = true;
      if (this.productAliasChecked) {
        this.onProductAliasChecked();
      }
      this.sdsOriginChecked = true;
      if (this.sdsOriginChecked) {
        this.onSdsOriginChecked();
      }
      this.sdsFormatChecked = true;
      if (this.sdsFormatChecked) {
        this.onSdsFormatChecked();
      }
      this.discontinuedChecked = true;
      if (this.discontinuedChecked) {
        this.onDiscontinuedChecked();
      }
      this.exemptWHMISChecked = true;
      if (this.exemptWHMISChecked) {
        this.onWHMISExemptChecked();
      }
      this.exemptionClassChecked = true;
      if (this.exemptionClassChecked) {
        this.onExemptionClassChecked();
      }
      this.additionalSupplierChecked = true;
      if (this.additionalSupplierChecked) {
        this.onAdditionalSuppliersChecked();
      }
      this.registrationNumberChecked = true;
      if (this.registrationNumberChecked) {
        this.onRegistrationNumberChecked();
      }
    } else {
      this.productNameChecked = false;
      this.productName = '';
      this.productCodeChecked = false;
      this.productCode = '';
      this.manufacturerNameChecked = false;
      this.manufacturerName = '';
      this.sdsFileChecked = false;
      this.sdsFile = '';
      this.sdsURLChecked = false;
      this.sdsURL = '';
      this.creationDateChecked = false;
      this.creationDate = '';
      this.dateAddedChecked = false;
      this.dateAdded = '';
      this.lastVerifiedDateChecked = false;
      this.lastVerifiedDate = '';
      this.notesChecked = false;
      this.notes = '';
      this.modifiedDateChecked = false;
      this.modifiedDate = '';
      this.revisionDateChecked = false;
      this.revisionDate = '';
      this.productAliasChecked = false;
      this.productAlias = '';
      this.sdsOriginChecked = false;
      this.sdsOrigin = '';
      this.sdsFormatChecked = false;
      this.sdsFormat = '';
      this.discontinuedChecked = false;
      this.discontinued = '';
      this.exemptWHMISChecked = false;
      this.exemptWHMIS = '';
      this.exemptionClassChecked = false;
      this.exemptionClass = '';
      this.additionalSupplierChecked = false;
      this.additionalSupplier = '';
      this.registrationNumberChecked = false;
      this.registrationNumber = '';
    }
  }

  getCheckedValues() {
    const result = [];
    if (this.productNameChecked) { result.push(this.productName); }
    if (this.productCodeChecked) { result.push(this.productCode); }
    if (this.manufacturerNameChecked) { result.push(this.manufacturerName); }
    if (this.sdsFileChecked) { result.push(this.sdsFile); }
    if (this.sdsURLChecked) { result.push(this.sdsURL); }
    if (this.creationDateChecked) { result.push(this.creationDate); }
    if (this.dateAddedChecked && !this.dateAddedDisabled) { result.push(this.dateAdded); }
    if (this.lastVerifiedDateChecked) { result.push(this.lastVerifiedDate); }
    if (this.notesChecked) { result.push(this.notes); }
    if (this.modifiedDateChecked) { result.push(this.modifiedDate); }
    if (this.revisionDateChecked) { result.push(this.revisionDate); }
    if (this.productAliasChecked) { result.push(this.productAlias); }
    if (this.sdsOriginChecked) { result.push(this.sdsOrigin); }
    if (this.sdsFormatChecked) { result.push(this.sdsFormat); }
    if (this.discontinuedChecked) { result.push(this.discontinued); }
    if (this.exemptWHMISChecked) { result.push(this.exemptWHMIS); }
    if (this.exemptionClassChecked) { result.push(this.exemptionClass); }
    if (this.additionalSupplierChecked) { result.push(this.additionalSupplier); }
    if (this.registrationNumberChecked) { result.push(this.registrationNumber); }
    return result;
  }
}
